import React, { useState, useEffect } from "react";

import Heading from "../../Components/Heading?v=0.0.2";
import Description from "../../Components/Description?v=0.0.2";
import CustomLink from "../../Components/CustomLink?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import EmailTextField from "../../Components/EmailTextField?v=0.0.2";
import PasswordTextField from "../../Components/PasswordTextField?v=0.0.2";
import OTPTextField from "../../Components/OTPTextField?v=0.0.2";

import * as Constants from "../../Constants?v=0.0.2";
import * as SignUpController from "../../Controllers/myBooks/SignUpController?v=0.0.2";
import FeatureCardContainer from "../../Components/FeatureCardContainer?v=0.0.2";

import InstallMobileAppsImage from "../../Images/InstallMobileAppsImage.svg";
import AppleStoreImage from "../../Images/AppleStoreImage.svg";
import PlayStoreImage from "../../Images/PlayStoreImage.svg";
import Business_Illustartion from "../../Images/Business_Illustartion.svg";
import Cloud_Illustration from "../../Images/Cloud_Illustration.svg";
import Tracking_Illustration from "../../Images/Tracking_Illustration.svg";

function SignUp(props) {
  document.title = "myBooks | Sign Up";
  const environment = props.environment;
  const [checkAPI, setCheckAPI] = useState({
    dataStatus: { isSuccess: props.validEmail },
  });
  const [otpVerifiedSuccessfully, setOtpVerifiedSuccessfully] = useState(false);
  const [otpSentSuccessfully, setOtpSentSuccessfully] = useState(false);
  const [emailTFResultLabelFlag, setEmailTFResultLabelFlag] = useState(false);
  const [emailTFResultLabel, setEmailTFResultLabel] = useState("");
  const [otpTFResultLabelFlag, setOtpTFResultLabelFlag] = useState(false);
  const [otpTFResultLabel, setOtpTFResultLabel] = useState("");
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState(props.email);
  const [validEmail, setValidEmail] = useState(
    Constants.validateEmail(props.email)
  );
  const [number, setNumber] = useState("");
  const [validNumber, setValidNumber] = useState(false);
  const [password, setPassword] = useState(props.password);
  const [validPassword, setValidPassword] = useState(props.validPassword);
  const [passwordLabel, setPasswordLabel] = useState("");
  const [showEmailLoader, setShowEmailLoader] = useState(false);
  const [showOtpVerificationLoader, setShowOtpVerificationLoader] =
    useState(false);
  const [numberChanged, setNumberChanged] = useState(false);
  const [googleLoader, setGoogleLoader] = useState(false);
  const [appleLoader, setAppleLoader] = useState(false);
  const [facebookLoader, setFacebookLoader] = useState(false);
  let [validateBlur, setValidateBlur] = useState(false);

  useEffect(() => {
    window.AppleID.auth.init({
      clientId: "com.zetran.mybooksw",
      scope: "email name",
      redirectURI: environment.loginAppUrl + "/myBooks/signup",
      state: Constants.generateRandomString(30),
      usePopup: true,
    });
    const sendOtp = (string) => {
      setShowEmailLoader(true);
      fetch(environment.loginAppAPI + Constants.sendOtp, {
        method: "POST",
        body: JSON.stringify({
          otpdetails: {
            username: string,
            usernametype: "phoneNumber",
            phoneNumberCode: "+91",
            phoneNumber: string,
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            setShowEmailLoader(false);
            setOtpSentSuccessfully(result.dataStatus.isSuccess);
            setEmailTFResultLabel(result.dataStatus.message);
            setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
          },
          (error) => {
            console.log(error);
          }
        );
      setNumber(email);
      setValidNumber(true);
      setCheckAPI((prevState) => {
        return { ...prevState, dataStatus: { isSuccess: false } };
      });
    };

    if (props.responseInvalidMessage === "This user doesn't have a account !") {
      props.showToast(
        "It seems like you are not registered with myBooks yet. Sign Up to continue."
      );
      props.clearResponseData();
      if (props.User.usernametype === "phoneNumber") {
        sendOtp(email);
      } else {
        setShowEmailLoader(true);
        fetch(environment.indLoginAppAPI + Constants.emailCheck, {
          method: "POST",
          body: JSON.stringify({
            User: {
              username: props.User.username,
              usernametype: "email",
            },
          }),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then(
            (result) => {
              if (result.dataStatus.isSuccess) {
                fetch(environment.globalLoginAppAPI + Constants.emailCheck, {
                  method: "POST",
                  body: JSON.stringify({
                    User: {
                      username: email,
                      usernametype: "email",
                    },
                  }),
                  headers: {
                    "Content-Type": "application/json",
                  },
                })
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      setShowEmailLoader(false);
                      setCheckAPI(result);
                      if (!result.dataStatus.isSuccess) {
                        setEmailTFResultLabel(result.dataStatus.message);
                        setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
                      }
                    },
                    (error) => {
                      console.log(error);
                    }
                  );
              } else {
                setShowEmailLoader(false);
                setCheckAPI(result);
                setEmailTFResultLabel(result.dataStatus.message);
                setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    }

    async function checkIdToken() {
      var id_token =
        props.id_one_tap !== ""
          ? props.id_one_tap
          : window.location.hash.split(/&|=/)[3];
      if (id_token && id_token.length > 0) {
        setGoogleLoader(true);
        let result = await fetch(
          environment.indLoginAppAPI + Constants.signInCheck,
          {
            method: "POST",
            body: JSON.stringify({
              User: {
                id_token: id_token,
              },
            }),
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())
          .then(
            (result) => {
              return new Promise((resolve, reject) => {
                resolve(result);
              });
            },
            (error) => {
              return new Promise((resolve, reject) => {
                reject(error);
              });
            }
          );
        if (result.dataStatus && result.dataStatus.isSuccess) {
          if (
            Object.keys(result.payload).length &&
            result.payload.entry_method === "login"
          ) {
            let User = {
              socialLogin: true,
              socialLoginVia: "Google",
              username: result.payload.email,
              id_token: id_token,
            };
            var loginObject = {
              username: User.username,
              id_token: User.id_token,
            };
            var loginAPI = "/oauth/login";
            result = await fetch(
              environment.loginAppAPI + Constants.loginUrlCheck,
              {
                method: "POST",
                body: JSON.stringify({ User: User }),
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
              .then((res) => res.json())
              .then(
                (result) => {
                  return result;
                },
                (error) => {
                  return error;
                }
              );
            setGoogleLoader(false);
            loginPath(result, loginObject, User, loginAPI);
          } else if (
            Object.keys(result.payload).length &&
            result.payload.entry_method === "signup"
          ) {
            result = await fetch(
              environment.globalLoginAppAPI + Constants.signInCheck,
              {
                method: "POST",
                body: JSON.stringify({
                  User: {
                    id_token: id_token,
                  },
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
              .then((res) => res.json())
              .then(
                (result) => {
                  return new Promise((resolve, reject) => {
                    resolve(result);
                  });
                },
                (error) => {
                  return new Promise((resolve, reject) => {
                    reject(error);
                  });
                }
              );
            if (result.dataStatus && result.dataStatus.isSuccess) {
              if (
                Object.keys(result.payload).length &&
                result.payload.entry_method === "login"
              ) {
                let User = {
                  socialLogin: true,
                  socialLoginVia: "Google",
                  username: result.payload.email,
                  id_token: id_token,
                };
                loginObject = {
                  username: User.username,
                  id_token: User.id_token,
                };
                loginAPI = "/oauth/login";
                result = await fetch(
                  environment.loginAppAPI + Constants.loginUrlCheck,
                  {
                    method: "POST",
                    body: JSON.stringify({ User: User }),
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                )
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      return result;
                    },
                    (error) => {
                      return error;
                    }
                  );
                setGoogleLoader(false);
                loginPath(result, loginObject, User, loginAPI);
              } else if (
                Object.keys(result.payload).length &&
                result.payload.entry_method === "signup"
              ) {
                let User = {
                  socialLogin: true,
                  socialLoginVia: "Google",
                  username: result.payload.email,
                  usernametype: "email",
                  id_token: id_token,
                };
                Constants.remove_hash_from_url();
                setGoogleLoader(false);

                props.onDone({ User: User });
              }
            }
          }
        } else {
          setGoogleLoader(false);
        }
      }
    }
    const loginPath = (result, loginObject, User, loginAPI) => {
      if (result.dataStatus && result.dataStatus.isSuccess) {
        if (result.payload && result.payload === "usa") {
          SignUpController.sendSignInData(
            true,
            environment.globalLoginAppAPI + loginAPI,
            environment.globalmyBooksAppUrl,
            loginObject,
            User
          );
        } else if (result.payload && result.payload === "india") {
          SignUpController.sendSignInData(
            true,
            environment.indLoginAppAPI + loginAPI,
            environment.indmyBooksAppUrl,
            loginObject,
            User
          );
        } else {
          SignUpController.sendSignInData(
            true,
            environment.globalLoginAppAPI + loginAPI,
            environment.globalmyBooksAppUrl,
            loginObject,
            User
          );
        }
      } else {
        SignUpController.sendSignInData(
          true,
          environment.globalLoginAppAPI + loginAPI,
          environment.globalmyBooksAppUrl,
          loginObject,
          User
        );
      }
    };
    checkIdToken();
  }, [environment, props, number, otp, email]);

  const loginPath = (result, loginObject, User, loginAPI) => {
    if (result.dataStatus && result.dataStatus.isSuccess) {
      if (result.payload && result.payload === "usa") {
        SignUpController.sendSignInData(
          true,
          environment.globalLoginAppAPI + loginAPI,
          environment.globalmyBooksAppUrl,
          loginObject,
          User
        );
      } else if (result.payload && result.payload === "india") {
        SignUpController.sendSignInData(
          true,
          environment.indLoginAppAPI + loginAPI,
          environment.indmyBooksAppUrl,
          loginObject,
          User
        );
      } else {
        SignUpController.sendSignInData(
          true,
          environment.globalLoginAppAPI + loginAPI,
          environment.globalmyBooksAppUrl,
          loginObject,
          User
        );
      }
    } else {
      SignUpController.sendSignInData(
        true,
        environment.globalLoginAppAPI + loginAPI,
        environment.globalmyBooksAppUrl,
        loginObject,
        User
      );
    }
  };

  const facebookSignInCheck = (token, socialLoginType) => {
    var User = {
      id_token: token,
      app_type: socialLoginType,
    };
    fetch(environment.loginAppAPI + "/signInCheck", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        User: User,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.dataStatus && result.dataStatus.isSuccess) {
            if (
              Object.keys(result.payload).length &&
              result.payload.entry_method === "login"
            ) {
              User = {
                socialLogin: true,
                socialLoginVia: socialLoginType,
                username: result.payload.email,
                id_token: token,
                app_type: socialLoginType,
              };
              var loginObject = {
                username: User.username,
                id_token: User.id_token,
              };
              var loginAPI = "/oauth/login";
              fetch(environment.loginAppAPI + Constants.loginUrlCheck, {
                method: "POST",
                body: JSON.stringify({ User: User }),
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    setFacebookLoader(false);
                    setAppleLoader(false);
                    loginPath(result, loginObject, User, loginAPI);
                  },
                  (error) => {
                    console.log(error);
                  }
                );
            } else if (
              Object.keys(result.payload).length &&
              result.payload.entry_method === "signup"
            ) {
              User = {
                socialLogin: true,
                socialLoginVia: socialLoginType,
                username: result.payload.email,
                usernametype: "email",
                id_token: token,
                app_type: socialLoginType,
              };
              setFacebookLoader(false);
              setAppleLoader(false);

              props.onDone({ User: User });
            }
          } else {
            setFacebookLoader(false);
            setAppleLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const sendOtp = (string) => {
    if (
      ((props.User.otp !== "" && props.otpVerifiedSuccessfully) ||
        (otp !== "" && otpVerifiedSuccessfully)) &&
      !numberChanged
    ) {
      setEmailTFResultLabelFlag(true);
      setEmailTFResultLabel("Phone number already verified successfully.");
      setCheckAPI((prevState) => {
        return {
          ...prevState,
          dataStatus: { isSuccess: true },
        };
      });
    } else if (!otpSentSuccessfully) {
      setShowEmailLoader(true);
      fetch(environment.loginAppAPI + Constants.sendOtp, {
        method: "POST",
        body: JSON.stringify({
          otpdetails: {
            username: string,
            usernametype: "phoneNumber",
            phoneNumberCode: "+91",
            phoneNumber: string,
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            setShowEmailLoader(false);
            setOtpSentSuccessfully(result.dataStatus.isSuccess);
            setEmailTFResultLabel(result.dataStatus.message);
            setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  const resendOtpHandler = () => {
    setEmailTFResultLabel("");
    setEmailTFResultLabelFlag(false);
    setCheckAPI((prevState) => {
      return {
        ...prevState,
        dataStatus: { isSuccess: otp === "" ? false : true },
      };
    });
    setOtpVerifiedSuccessfully(false);
    setOtpTFResultLabel("");
    setOtpTFResultLabelFlag(false);
    sendOtp(number);
  };

  const verifyOtpHandler = (otpText) => {
    setOtp(otpText);
    setShowOtpVerificationLoader(true);
    fetch(environment.loginAppAPI + Constants.verifyOtp, {
      method: "POST",
      body: JSON.stringify({
        otpdetails: {
          username: number,
          usernametype: "phoneNumber",
          phoneNumberCode: "+91",
          phoneNumber: number,
          otp: otpText,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setShowOtpVerificationLoader(false);
          setCheckAPI(result);
          setOtpVerifiedSuccessfully(result.dataStatus.isSuccess);
          setOtpTFResultLabel(result.dataStatus.message);
          setOtpTFResultLabelFlag(true);
          if (result.dataStatus.message === "Mobile no. already verified") {
            setCheckAPI((prevState) => {
              return {
                ...prevState,
                dataStatus: { isSuccess: true },
              };
            });
            setOtpVerifiedSuccessfully(true);
          }
          if (result.dataStatus.isSuccess) {
            setNumberChanged(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const onEmailTFChange = (email) => {
    setEmailTFResultLabel("");
    setEmail((prevState) => {
      return email;
    });
    setCheckAPI((prevState) => {
      return { ...prevState, dataStatus: { isSuccess: false } };
    });
    setNumberChanged(true);
  };

  const onValidEmailHandler = (currentEmail) => {
    setEmail((prevState) => {
      return currentEmail;
    });
    setValidNumber(false);
  };

  const changeEmailFlagHandler = (flag, currentEmail) => {
    setEmailTFResultLabelFlag(flag);
    setCheckAPI((prevState) => {
      return { ...prevState, dataStatus: { isSuccess: false } };
    });
    setOtpSentSuccessfully(false);
    setOtpTFResultLabelFlag(false);
    setValidEmail((prevState) => {
      return flag;
    });
    if (!flag) {
      setEmailTFResultLabel((prevState) => {
        return currentEmail !== ""
          ? "Please enter a valid email address or phone number."
          : "";
      });
    } else {
      setEmailTFResultLabel((prevState) => {
        return "";
      });
      setShowEmailLoader(true);
      fetch(environment.indLoginAppAPI + Constants.emailCheck, {
        method: "POST",
        body: JSON.stringify({
          User: {
            username: currentEmail,
            usernametype: "email",
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            if (result.dataStatus.isSuccess) {
              fetch(environment.globalLoginAppAPI + Constants.emailCheck, {
                method: "POST",
                body: JSON.stringify({
                  User: {
                    username: currentEmail,
                    usernametype: "email",
                  },
                }),
                headers: {
                  "Content-Type": "application/json",
                },
              })
                .then((res) => res.json())
                .then(
                  (result) => {
                    setShowEmailLoader(false);
                    setCheckAPI(result);
                    if (!result.dataStatus.isSuccess) {
                      setEmailTFResultLabel(result.dataStatus.message);
                      setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
                      setValidateBlur(false);
                    } else {
                      if (validateBlur) {
                        SignUp();
                        setValidateBlur(false);
                      }
                    }
                  },
                  (error) => {
                    console.log(error);
                  }
                );
            } else {
              setShowEmailLoader(false);
              setCheckAPI(result);
              setEmailTFResultLabel(result.dataStatus.message);
              setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
              setValidateBlur(false);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  const onValidNumberHandler = (currentNumber) => {
    setNumber((prevState) => {
      return currentNumber;
    });
    setValidEmail(false);
  };

  const changeNumberFlagHandler = (flag, currentNumber) => {
    setEmailTFResultLabelFlag(flag);
    setCheckAPI((prevState) => {
      return { ...prevState, dataStatus: { isSuccess: false } };
    });
    setValidNumber((prevState) => {
      return flag;
    });
    if (!flag) {
      setEmailTFResultLabel((prevState) => {
        return "Please enter a 10-digit phone number.";
      });
    } else if (!otpSentSuccessfully) {
      setEmailTFResultLabel((prevState) => {
        return "";
      });
      setShowEmailLoader(true);
      fetch(environment.loginAppAPI + Constants.phoneNumberCheck, {
        method: "POST",
        body: JSON.stringify({
          User: {
            phoneNumber: currentNumber,
            usernametype: "phoneNumber",
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            setShowEmailLoader(false);
            if (result.dataStatus.isSuccess) {
              sendOtp(currentNumber);
            } else {
              setCheckAPI(result);
              setEmailTFResultLabel(result.dataStatus.message);
              setEmailTFResultLabelFlag(result.dataStatus.isSuccess);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  const onValidPasswordHandler = (currentPassword) => {
    setPassword((prevState) => {
      return currentPassword;
    });
  };

  const changePasswordFlagHandler = (flag) => {
    setValidPassword((prevState) => {
      return flag;
    });
    setPasswordLabel(
      "* Password should be of minimum 8 characters and maximum 40 characters, with uppercase,lowercase,numerics and a special character."
    );
  };

  const onNext = (event) => {
    if (email.length === 0 && number.length === 0) {
      setEmailTFResultLabel((prevState) => {
        return "*Email address / Phone Number is required.";
      });
    }
    if (!props.socialLogin) {
      if (password.length === 0) {
        setPassword((prevState) => {
          return "";
        });
        setPasswordLabel("*Password is required.");
      }
    }
    if (
      !checkAPI.dataStatus.isSuccess &&
      (email.length !== 0 || number.length !== 0)
    ) {
      if (Constants.isNumber(email)) {
        setNumber(email);
        onValidNumberHandler(email);
        changeNumberFlagHandler(email.length === 10, email);
      } else {
        setValidateBlur(true);
        onValidEmailHandler(email);
        changeEmailFlagHandler(Constants.validateEmail(email), email);
      }
    }
    if (checkAPI.dataStatus.isSuccess && validPassword) {
      SignUp();
    }
  };

  const SignUp = () => {
    if (props.User.phoneNumber !== "" && !validEmail) {
      props.onDone({
        User: {
          ...props.User,
        },
      });
    } else {
      props.onDone({
        User: {
          otp: otp,
          phoneNumber: number,
          phoneNumberCode: "+91",
          username: email,
          usernametype: validEmail ? "email" : validNumber ? "phoneNumber" : "",
          password: password,
          socialLogin: false,
          socialLoginVia: "Login",
        },
      });
    }
    props.setOtpVerifiedSuccessfully(
      otpVerifiedSuccessfully || props.otpVerifiedSuccessfully
    );
  };

  const googleSignUp = (event) => {
    SignUpController.signIn(true, "Google", environment.loginAppUrl);
  };

  const appleSignUp = async (event) => {
    try {
      setAppleLoader(true);
      const data = await window.AppleID.auth.signIn();
      facebookSignInCheck(data.authorization.id_token, "apple");
    } catch (error) {
      console.log(error);
      setAppleLoader(false);
    }
  };

  const facebookSignUp = (event) => {
    window.FB.getLoginStatus(function (response) {
      if (response.authResponse && response.status === "connected") {
        let facebook = response;
        setFacebookLoader(true);
        facebookSignInCheck(facebook.authResponse.accessToken, "facebook");
      } else {
        window.FB.login(
          function (response) {
            if (response.authResponse && response.status === "connected") {
              let facebook = response;
              setFacebookLoader(true);
              facebookSignInCheck(
                facebook.authResponse.accessToken,
                "facebook"
              );
            } else {
              window.FB.logout(function (response) {
                console.log(response);
              });
              console.log("User cancelled login or did not fully authorize.");
              setFacebookLoader(false);
            }
          },
          {
            scope: "email",
            return_scopes: true,
          }
        );
      }
    });
  };

  return (
    <div className="App col-12 d-flex align-items-lg-center align-items-start myBooks">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-7 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column justify-content-between h-100 margin-interaction-card">
              <div className="mb-3">
                <Heading text="Sign up to manage your business accounting easier"></Heading>
                <Description
                  className="d-block mb-4 description"
                  text="A simple, powerful solution for your business"
                />
                <FeatureCardContainer
                  data={[
                    {
                      heading: "Easy cloud-based  online app",
                      description:
                        "Can access from anywhere through web, android & IOS",
                      slideImage: Cloud_Illustration,
                    },
                    {
                      heading: "Manage Multiple Business Accounts",
                      description:
                        "Manage multiple business accounts and support multi-users at an affordable price.",
                      slideImage: Business_Illustartion,
                    },
                    {
                      heading: "Hussle Free Tracking, Saves your time",
                      description:
                        "Required less time to track your business. Handy reports can check any time",
                      slideImage: Tracking_Illustration,
                    },
                  ]}
                />
              </div>
              {false && (
                <div className="padding-top">
                  <CustomLink
                    to=""
                    text="I Have A Referral Code !"
                  ></CustomLink>
                  <HighlightText
                    className="p1"
                    subClassName="bold-green-text"
                    text1="Congrats!!! You have an"
                    text2="off on premium Upgrade"
                    subText="Extra 10%"
                  ></HighlightText>
                </div>
              )}
              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-md-12 d-flex d-lg-none align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-wrap align-items-center margin-interaction-card">
              <div className="download-mobile-apps-parent w-100 d-flex flex-wrap align-items-center">
                <img src={InstallMobileAppsImage} alt=""></img>
                <div>
                  <div className="d-block text-align-left feature-card-heading mb-2">
                    Install our Android & IOS App
                  </div>
                  <div className="d-block text-align-left description">
                    Install the app and keep updated on your mobile.
                  </div>
                </div>
              </div>
              <div className="download-mobile-apps-parent w-100 d-flex flex-wrap align-items-center justify-content-center mt-2">
                <a
                  href="https://play.google.com/store/apps/details?id=com.zetran.mybooks&hl=en_IN&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={PlayStoreImage} alt=""></img>
                </a>
                <a
                  href="https://apps.apple.com/us/app/mybooks-accounting-invoices/id1414930118"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={AppleStoreImage} alt=""></img>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-12 d-lg-flex d-block align-items-center bg-white blr-20">
            <div className="mx-auto mx-lg-0 interaction-card">
              <div className="d-flex flex-wrap justify-content-center">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myBooks_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <div className="font-20-600 d-lg-none b-block my-3">
                Sign up to take control of your business accounting
              </div>
              <div className="top-bottom-15-padding social-login-icon-container d-flex align-items-center justify-content-around">
                <div
                  className="google-icon-parent d-flex flex-wrap align-items-center cursor-pointer"
                  onClick={googleSignUp}
                >
                  {!googleLoader && (
                    <img
                      src="https://cdn.zetran.com/assets-mybooks/accounts-portal/GoogleIcon.png"
                      alt=""
                      className="side-logo"
                    ></img>
                  )}
                  {googleLoader && (
                    <div className="side-logo d-flex align-items-center justify-content-center">
                      <div
                        className="spinner-border purple"
                        role="status"
                      ></div>
                    </div>
                  )}
                  <div className="google-icon-label">Sign Up with Google</div>
                </div>

                {!appleLoader && (
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={appleSignUp}
                    className="side-logo apple"
                  >
                    <path
                      className="apple-logo"
                      d="M14.94 5.19C15.3181 4.75428 15.6063 4.24817 15.7882 3.70074C15.9701 3.1533 16.0421 2.57533 16 2C14.8394 2.09369 13.762 2.63956 13 3.52C12.6351 3.94198 12.3586 4.43288 12.1868 4.96364C12.015 5.49441 11.9515 6.05424 12 6.61C12.5661 6.61472 13.1258 6.4891 13.6356 6.24286C14.1454 5.99662 14.5917 5.63637 14.94 5.19ZM17.46 12.63C17.4667 11.8637 17.6685 11.1118 18.0465 10.4452C18.4244 9.77859 18.9659 9.21926 19.62 8.82C19.2072 8.22524 18.6615 7.73483 18.0262 7.38767C17.3909 7.04052 16.6835 6.84615 15.96 6.82C14.4 6.66 12.96 7.73 12.13 7.73C11.3 7.73 10.13 6.84 8.83 6.86C7.98013 6.888 7.15202 7.13578 6.42645 7.57919C5.70088 8.02259 5.10261 8.64648 4.69 9.39C2.93 12.45 4.24 17 6 19.47C6.8 20.68 7.8 22.05 9.12 22C10.44 21.95 10.87 21.18 12.4 21.18C13.93 21.18 14.4 22 15.7 21.97C17 21.94 17.92 20.73 18.76 19.52C19.355 18.6415 19.8199 17.6816 20.14 16.67C19.3475 16.332 18.6713 15.7693 18.195 15.0513C17.7188 14.3333 17.4632 13.4916 17.46 12.63Z"
                      fill="black"
                    />
                  </svg>
                )}
                {appleLoader && (
                  <div className="side-logo d-flex align-items-center justify-content-center">
                    <div className="spinner-border purple" role="status"></div>
                  </div>
                )}

                {!facebookLoader && (
                  <svg
                    className="side-logo facebook"
                    onClick={facebookSignUp}
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.75"
                      y="0.75"
                      width="20.5"
                      height="20.5"
                      rx="1.25"
                      fill="#1477FA"
                      stroke="#1477FA"
                      strokeWidth="0.5"
                      className="facebook-stroke"
                    />
                    <path
                      className="facebook-path"
                      d="M19.9 1H2.1C1.80826 1 1.52847 1.11589 1.32218 1.32218C1.11589 1.52847 1 1.80826 1 2.1V19.9C1 20.0445 1.02845 20.1875 1.08373 20.321C1.13901 20.4544 1.22004 20.5757 1.32218 20.6778C1.42433 20.78 1.54559 20.861 1.67905 20.9163C1.81251 20.9715 1.95555 21 2.1 21H11.68V13.25H9.08V10.25H11.68V8C11.6261 7.47176 11.6885 6.93813 11.8627 6.43654C12.0369 5.93495 12.3188 5.47755 12.6885 5.09641C13.0582 4.71528 13.5068 4.41964 14.0028 4.23024C14.4989 4.04083 15.0304 3.96225 15.56 4C16.3383 3.99521 17.1163 4.03528 17.89 4.12V6.82H16.3C15.04 6.82 14.8 7.42 14.8 8.29V10.22H17.8L17.41 13.22H14.8V21H19.9C20.0445 21 20.1875 20.9715 20.321 20.9163C20.4544 20.861 20.5757 20.78 20.6778 20.6778C20.78 20.5757 20.861 20.4544 20.9163 20.321C20.9715 20.1875 21 20.0445 21 19.9V2.1C21 1.95555 20.9715 1.81251 20.9163 1.67905C20.861 1.54559 20.78 1.42433 20.6778 1.32218C20.5757 1.22004 20.4544 1.13901 20.321 1.08373C20.1875 1.02845 20.0445 1 19.9 1Z"
                      fill="white"
                    />
                  </svg>
                )}
                {facebookLoader && (
                  <div className="side-logo d-flex align-items-center justify-content-center">
                    <div className="spinner-border purple" role="status"></div>
                  </div>
                )}
              </div>
              <div className="bottom-15-padding">
                <label className="label">
                  Enter your Mail ID or Phone Number
                </label>
                <EmailTextField
                  className={`${email !== "" ? "value-entered" : ""}`}
                  value={email}
                  showLoader={showEmailLoader}
                  onChange={onEmailTFChange}
                  onValidEmail={onValidEmailHandler}
                  changeEmailFlag={changeEmailFlagHandler}
                  onValidNumber={onValidNumberHandler}
                  changeNumberFlag={changeNumberFlagHandler}
                  isSignUp={true}
                ></EmailTextField>
                {emailTFResultLabel.length !== 0 && (
                  <label
                    className={`result-label ${
                      emailTFResultLabelFlag ? "valid-label" : ""
                    }`}
                  >
                    {emailTFResultLabel}
                  </label>
                )}
              </div>
              {otpSentSuccessfully && (
                <div className="bottom-15-padding">
                  <label className="label">Enter the OTP Number</label>
                  <OTPTextField
                    showLoader={showOtpVerificationLoader}
                    className={`${otp !== "" ? "value-entered" : ""}`}
                    resendOtp={resendOtpHandler}
                    verifyOtp={verifyOtpHandler}
                    onChange={() => {
                      setOtpTFResultLabel("");
                      setOtpTFResultLabelFlag(false);
                    }}
                  ></OTPTextField>
                  {otpTFResultLabelFlag && (
                    <label
                      className={`result-label ${
                        otpVerifiedSuccessfully ? "valid-label" : ""
                      }`}
                    >
                      {otpTFResultLabel}
                    </label>
                  )}
                </div>
              )}
              <div className="mb-2">
                <label className="label">Set up your Password</label>
                <PasswordTextField
                  className={`${password !== "" ? "value-entered" : ""}`}
                  value={password}
                  onValid={onValidPasswordHandler}
                  changeFlag={changePasswordFlagHandler}
                  onBlur={() => {}}
                  isSignUp={true}
                ></PasswordTextField>
                {(password !== "" ||
                  passwordLabel === "*Password is required.") &&
                  !validPassword && (
                    <label className="result-label">{passwordLabel}</label>
                  )}
                {validPassword && (
                  <label className="account-safe-label">
                    <i className="fas fa-check-circle success-tick"></i>Your
                    password is secure
                  </label>
                )}
              </div>
              <div className="my-3">
                <div className="terms-and-policy text-align-left">
                  By signing up, you are agreeing to our{" "}
                  <a
                    href="https://www.zetran.com/mybooks/securitypolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blue"
                  >
                    terms of services
                  </a>{" "}
                  &{" "}
                  <a
                    href="https://www.zetran.com/privacypolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="blue"
                  >
                    privacy policy
                  </a>
                </div>
              </div>
              <div className="bottom-15-padding">
                <button
                  className="button d-flex flex-wrap align-items-center justify-content-center"
                  onClick={onNext}
                >
                  {!props.showLoader && (
                    <>
                      <div className="mr-2">Get Started</div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Outline"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                      >
                        <path
                          fill="#fff"
                          d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                        />
                      </svg>
                    </>
                  )}
                  {props.showLoader && (
                    <div className="spinner-border" role="status"></div>
                  )}
                </button>
              </div>
              <div className="d-flex flex-wrap align-items-center justify-content-center my-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Filled"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                >
                  <path
                    fill="#27AE60"
                    d="M18.581,2.14,12.316.051a1,1,0,0,0-.632,0L5.419,2.14A4.993,4.993,0,0,0,2,6.883V12c0,7.563,9.2,11.74,9.594,11.914a1,1,0,0,0,.812,0C12.8,23.74,22,19.563,22,12V6.883A4.993,4.993,0,0,0,18.581,2.14ZM16.718,9.717l-4.272,4.272a1.873,1.873,0,0,1-1.335.553h-.033a1.872,1.872,0,0,1-1.345-.6l-2.306-2.4A1,1,0,1,1,8.868,10.16L11.112,12.5,15.3,8.3a1,1,0,0,1,1.414,1.414Z"
                  />
                </svg>
                <div className="font-12-400 d-inline grey mx-2">
                  Safe & Secure
                </div>
              </div>
              <div className="d-flex flex-wrap align-items-center justify-content-center">
                <div className="font-12-400 d-inline">
                  Already using myBooks ?
                </div>
                <CustomLink
                  to="/myBooks/login"
                  text="Sign in"
                  hasOnClick={true}
                  onClick={() => {
                    props.clearData();
                  }}
                ></CustomLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SignUp;
